import { useMutation, useQuery } from "react-query";
import { createLetterTemplate, fetchLetterTemplateBody, fetchLetterTemplates, updateLetterTemplate } from "@/services/letter";

/** Variables accepted by the create-template mutation. */

/** Variables accepted by the update-template mutation. */

/**
 * Query hook for the workspace's templates. Defaults to `letter` so patient
 * letter pickers never receive SMS landing pages; pass `"all"` to list every type.
 */
export function useLetterTemplates(workspaceId) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "letter";
  return useQuery(["letter-templates", workspaceId, type], function () {
    return fetchLetterTemplates(workspaceId, true, type);
  }, {
    enabled: Boolean(workspaceId) && enabled
  });
}

/** Query hook for a single template's body. */
export function useLetterTemplateBody(workspaceId, templateId) {
  return useQuery(["letter-template-body", workspaceId, templateId], function () {
    return fetchLetterTemplateBody(workspaceId, templateId);
  }, {
    enabled: Boolean(workspaceId) && Boolean(templateId),
    staleTime: 0
  });
}

/** Mutation hook that creates a template. */
export function useCreateLetterTemplate(workspaceId) {
  return useMutation(function (_ref) {
    var name = _ref.name,
      template = _ref.template,
      type = _ref.type;
    return createLetterTemplate(workspaceId, name, template, type);
  });
}

/** Mutation hook that updates a template. */
export function useUpdateLetterTemplate(workspaceId) {
  return useMutation(function (_ref2) {
    var templateId = _ref2.templateId,
      name = _ref2.name,
      template = _ref2.template,
      type = _ref2.type;
    return updateLetterTemplate(workspaceId, templateId, name, template, type);
  });
}